import React, { useState } from "react";
import { Avatar, Button } from "antd";
import { EditOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import PageRoutes from "../../../../utils/routes";
import ImageUploadModal from "./ImageUploadModal";

function PersonnelHomeHeader({ imageUrl, name, surname, email }) {
  const navigate = useNavigate();
  const [isModalVisible, setIsModalVisible] = useState(false);

  const handleModalSuccess = () => {
    // You might want to refresh the user's data here
    setIsModalVisible(false);
  };

  return (
    <>
      <div
        style={{
          background: "linear-gradient(135deg, #e9d5ff 0%, #e0f2fe 100%)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "20px",
        }}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "16px",
            background: "white",
            padding: "20px",
            borderRadius: "12px",
            boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
            width: "100%",
          }}>
          <div style={{ position: "relative" }}>
            <Avatar
              src={imageUrl}
              size={80}
              style={{
                fontSize: "32px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}>
              {name?.[0]?.toUpperCase()}
            </Avatar>
            <Button
              onClick={() => setIsModalVisible(true)}
              style={{
                position: "absolute",
                bottom: 0,
                right: 0,
                height: 30,
                width: 30,
                background: "white",
                borderRadius: "50%",
                padding: "4px",
                boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
              }}>
              <EditOutlined />
            </Button>
          </div>

          <div style={{ flex: 1 }}>
            <h2
              style={{
                margin: 0,
                fontSize: "24px",
                fontWeight: 500,
                color: "#1f2937",
              }}>
              {name + " " + surname}
            </h2>
            <p
              style={{
                margin: "4px 0 0 0",
                color: "#6b7280",
                fontSize: "14px",
              }}>
              {email}
            </p>
          </div>

          <Button
            type="primary"
            onClick={() => {
              navigate(PageRoutes.personnelSettings);
            }}
            style={{
              background: "#8b5cf6",
              border: "none",
              boxShadow: "none",
              height: "36px",
              borderRadius: "6px",
            }}>
            Ayarlar
          </Button>
        </div>
      </div>

      <ImageUploadModal
        visible={isModalVisible}
        onClose={() => setIsModalVisible(false)}
        onSuccess={handleModalSuccess}
        currentImageUrl={imageUrl}
      />
    </>
  );
}

export default PersonnelHomeHeader;
